"use client";

import { useAuth, useUser } from "@clerk/nextjs";
import posthog from "posthog-js";
import { useEffect } from "react";

export function PostHogIdentify() {
  const { userId, isLoaded: authLoaded, has } = useAuth();
  const { user, isLoaded: userLoaded } = useUser();

  useEffect(() => {
    if (!authLoaded || !userLoaded) return;

    if (userId && user) {
      posthog.identify(userId, {
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName,
        created_at: user.createdAt?.toISOString(),
        is_pro: has?.({ plan: "pro" }) ?? false,
      });
    } else {
      posthog.reset();
    }
  }, [userId, authLoaded, userLoaded, user, has]);

  return null;
}
